"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserTech = exports.isUserAdminTech = void 0;

var isUserTech = function isUserTech() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return ["AS", "ADMIN-AS", "ADMIN"].includes(value);
};

exports.isUserTech = isUserTech;

var isUserAdminTech = function isUserAdminTech() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return ["ADMIN-AS", "ADMIN"].includes(value);
};

exports.isUserAdminTech = isUserAdminTech;